import {css} from 'lit';
export const styles = css`:host{display:block}:host([hidden]){display:none}`;
export default styles;
